module.exports = __webpack_public_path__ + "static/media/Rodrigo_Ramirez_Resume_2021.6a41b968.pdf";